import { BillingIntervalProto } from "@noom/noom-contracts/noom_contracts/billing/billing_interval";

export function getTrialDurationFromBillingInterval(
  billingInterval?: BillingIntervalProto
): number | undefined {
  const totalDays = getDaysFromBillingInterval(billingInterval);
  if (totalDays == null) {
    return undefined;
  }
  const trialDays = totalDays - 1;
  return trialDays > 0 ? trialDays : 0;
}

export function getDaysFromBillingInterval(
  billingInterval?: BillingIntervalProto
): number | undefined {
  if (!billingInterval) {
    return undefined;
  }
  if (billingInterval.unit === "DAYS") {
    return billingInterval.count;
  }
  if (billingInterval.unit === "WEEKS") {
    return billingInterval.count * 7;
  }
  if (billingInterval.unit === "MONTHS") {
    return billingInterval.count * 30;
  }
  throw new Error(
    `Not supported billing interval unit: ${billingInterval.unit}`
  );
}

export function convertBillingIntervalToMonths(
  billingInterval?: BillingIntervalProto
): number | undefined {
  if (!billingInterval) {
    return undefined;
  }
  if (billingInterval.unit === "WEEKS") {
    return Math.round(billingInterval.count / 4);
  }
  if (billingInterval.unit === "DAYS") {
    return Math.round(billingInterval.count / 30);
  }
  if (billingInterval.unit === "MONTHS") {
    return billingInterval.count;
  }
  throw new Error(`Unsupported billing interval unit: ${billingInterval.unit}`);
}

/**
 * Inverse of convertBillingIntervalToMonths: med checkout treats 1 month = 4 weeks
 * (not calendar days / 7, which would make 3 months ≈ 13 weeks).
 */
export function getBillingCycleInWeeks(
  billingInterval?: BillingIntervalProto
): number | undefined {
  if (!billingInterval) {
    return undefined;
  }
  if (billingInterval.unit === "WEEKS") {
    return billingInterval.count;
  }
  const months = convertBillingIntervalToMonths(billingInterval);
  return months != null ? months * 4 : undefined;
}
